import { MUIButton } from "@abb/arcadia-ui-react"
import { useCallback, useRef } from "react"
import { BackToURL } from "./BackToURL"

type FormPageProps = {
  returnURL: string
  onSubmit: () => void
  isSubmitting: boolean
  isDirty: boolean
  isValid: boolean
  children: React.ReactNode
}

export function FormPage({
  returnURL,
  onSubmit,
  isSubmitting,
  isDirty,
  isValid,
  children,
}: Readonly<FormPageProps>) {
  const submittingRef = useRef(false)

  const handleSubmit = useCallback(() => {
    if (submittingRef.current) {
      return
    }
    submittingRef.current = true
    onSubmit()
  }, [onSubmit])

  if (!isSubmitting) {
    submittingRef.current = false
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <BackToURL url={returnURL} />

        <MUIButton
          variant="primary"
          isLoading={isSubmitting}
          disabled={isSubmitting || !isDirty || !isValid}
          onClickButton={handleSubmit}
          label="Save"
          size={32}
        />
      </div>

      <div className="form-container" style={{ padding: "10px 20px" }}>
        {children}
      </div>
    </div>
  )
}

type FieldRowProps = {
  label: string
  children: React.ReactNode
}

export function FieldRow({ label, children }: Readonly<FieldRowProps>) {
  return (
    <div className="part" style={{ padding: "10px 0" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          gap: 8,
          alignItems: "center",
        }}
      >
        <div className="abb-label" style={{ gridColumn: "span 2" }}>
          {label}
        </div>

        <div style={{ gridColumn: "span 6" }}>{children}</div>
      </div>
    </div>
  )
}
